// extracted by mini-css-extract-plugin
module.exports = {"header":"style-module__header___3koeT","illustration":"style-module__illustration___2zJQU","iconBackground":"style-module__iconBackground___vlKSC"};